import type { ReactNode } from 'react'
import { appSettings } from '../../config/settings'

type StoreBadgeProps = {
  url?: string
  label: string
  eyebrow: string
  icon: ReactNode
}

const StoreBadge = ({ url, label, eyebrow, icon }: StoreBadgeProps) => {
  const content = (
    <>
      {icon}
      <span>
        <span className="store-badge-eyebrow">{url ? eyebrow : 'Coming soon to the'}</span>
        <br />
        <span className="big">{label}</span>
      </span>
    </>
  )

  if (!url) {
    return (
      <span className="store-badge soon" aria-disabled="true">
        {content}
      </span>
    )
  }

  return (
    <a className="store-badge" href={url} target="_blank" rel="noopener noreferrer">
      {content}
    </a>
  )
}

export const StoreBadges = () => {
  // Download badges — the store URLs come from appSettings, which resolves
  // from process.env on the server and window.__ENV__ on the client to the
  // same values before the first render, so SSR and hydration agree on which
  // variant (link vs "Coming soon" span) to emit — see config/settings.ts and
  // server/entry-server.tsx.
  const { appStoreUrl, playStoreUrl } = appSettings

  return (
    <div className="store-row">
      <StoreBadge
        url={appStoreUrl}
        eyebrow="Download on the"
        label="App Store"
        icon={
          <svg viewBox="0 0 24 24" fill="currentColor">
            <path d="M16.5 1.6c.1 1-.3 2-1 2.8-.7.8-1.8 1.4-2.8 1.3-.1-1 .4-2 1-2.7.7-.8 1.9-1.4 2.8-1.4zM20 17.4c-.5 1.2-.8 1.7-1.5 2.7-1 1.5-2.4 3.3-4.1 3.3-1.5 0-1.9-1-4-1-2 0-2.5 1-4 1-1.7 0-3-1.6-4-3.1-2.8-4.2-3.1-9.1-1.4-11.7 1-1.5 2.6-2.4 4.1-2.4 1.6 0 2.6 1 3.9 1 1.3 0 2-1 3.9-1 1.4 0 2.8.7 3.9 2-3.4 1.9-2.9 6.8.7 8.2z" />
          </svg>
        }
      />
      <StoreBadge
        url={playStoreUrl}
        eyebrow="Get it on"
        label="Google Play"
        icon={
          <svg viewBox="0 0 24 24" fill="currentColor">
            <path d="M3.6 2.3c-.3.3-.5.7-.5 1.3v16.8c0 .6.2 1 .5 1.3l.1.1L13 12.1v-.2L3.7 2.2l-.1.1z" />
            <path d="M16.2 15.3 13 12.1v-.2l3.2-3.2.1.1 3.8 2.2c1.1.6 1.1 1.7 0 2.3l-3.8 2.1-.1-.1z" />
            <path d="M16.3 15.2 13 12 3.6 21.7c.4.4 1 .4 1.7.1l11-6.6M16.3 8.8 6.3 2.2c-.7-.4-1.3-.3-1.7.1L13 12l3.3-3.2z" />
          </svg>
        }
      />
    </div>
  )
}
